import React, { useContext, useRef, useState } from 'react'
import './index.scss'
import Button from '@Components/Buttons/Button'
import { ICONS } from '@Const/common'
import { Link } from 'react-router'
import { observer } from 'mobx-react'
import Navigation from '@App/navigation'
import { StoresContext } from '@App/contexts'

const ButtonCreateNewWork = observer(() => {
    const { rightsholderStore } = useContext(StoresContext)
    const [popoverIsOpen, setPopoverIsOpen] = useState(false)
    const nodeComponent = useRef<HTMLDivElement>(null)

    const handleOutsideClick = (e: any) => {
        if (nodeComponent.current && nodeComponent.current.contains(e.target)) {
            return
        }
        handleClick()
    }

    const handleClick = () => {
        if (!popoverIsOpen) {
            document.addEventListener('click', handleOutsideClick, false)
        } else {
            document.removeEventListener('click', handleOutsideClick, false)
        }
        setPopoverIsOpen(!popoverIsOpen)
    }

    return (
        <div className="button-create-new-work-component">
            <Button mainColor type="primary" icon={ICONS.arrow_forward} onClick={handleClick}>
                Register Work
            </Button>
            {popoverIsOpen && (
                <div ref={nodeComponent} className="popover-create-new-work-component">
                    <div className="popover-arrow" />
                    <Link to={Navigation.rightholder.createWork.root(rightsholderStore.currentRightsholderId)}>
                        Individual
                    </Link>
                    <Link to={Navigation.rightholder.createWork.bulk.root(rightsholderStore.currentRightsholderId)}>
                        By File Upload
                    </Link>
                </div>
            )}
        </div>
    )
})

export default ButtonCreateNewWork
